import API_BASE_URL from "../../../../../../Constants";

const CreateUpdateElv3 = async (elv3Object, headers) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/inspections/posting/CreateElv3`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authtoken: headers?.authtoken ?? "",
          systemuser: headers?.systemuser ?? "",
        },
        body: JSON.stringify(elv3Object),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("ELV3 result: ", data);
    return data;
  } catch (error) {
    console.error("Error creating ELV3:", error);
    throw error;
  }
};

const OwnerLookup = async (ownerLookupObject, headers) => {
  console.log("Owner Lookup Object:", ownerLookupObject);
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/inspections/email-lookup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(ownerLookupObject),
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Owner Lookup Result:", data);
    return data;
  } catch (error) {
    console.error("Error fetching owner lookup:", error);
    throw error;
  }
};

const getDevices = async (devicePayload, headers) => {
  console.log(devicePayload);
  const response = await fetch(
    `${API_BASE_URL}/api/inspections/posting/get-devices`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authtoken: headers?.authtoken ?? "",
        systemuser: headers?.systemuser ?? "",
      },
      body: JSON.stringify(devicePayload),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

const validateDevices = async (validationPayload, headers) => {
  console.log("Validating devices with payload:", validationPayload);
  const response = await fetch(
    `${API_BASE_URL}/api/inspections/posting/validate-devices`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authtoken: headers?.authtoken ?? "",
        systemuser: headers?.systemuser ?? "",
      },
      body: JSON.stringify(validationPayload),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  return response.json();
};

const createDefects = async (defectsPayload, headers) => {
  try {
    console.log("Sending defects payload:", defectsPayload);

    const response = await fetch(
      `${API_BASE_URL}/api/inspections/posting/CreateUpdateElv3Defect`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authtoken: headers?.authtoken ?? "",
          systemuser: headers?.systemuser ?? "",
        },
        body: JSON.stringify(defectsPayload),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Defects creation result: ", data);
    return data;
  } catch (error) {
    console.error("Error creating defects:", error);
    throw error;
  }
};

export {
  CreateUpdateElv3,
  OwnerLookup,
  getDevices,
  validateDevices,
  createDefects,
};
